"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Popover2 = _interopRequireDefault(require("react-bootstrap/Popover"));

var _Tooltip = _interopRequireDefault(require("../tooltip/Tooltip"));

var _excluded = ["title", "titleClassName", "contentClassName", "children"];

var Popover = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var title = props.title,
      _props$titleClassName = props.titleClassName,
      titleClassName = _props$titleClassName === void 0 ? '' : _props$titleClassName,
      _props$contentClassNa = props.contentClassName,
      contentClassName = _props$contentClassNa === void 0 ? '' : _props$contentClassNa,
      children = props.children,
      remainingProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  return /*#__PURE__*/_react.default.createElement(_Popover2.default, (0, _extends2.default)({
    ref: ref
  }, remainingProps), title && /*#__PURE__*/_react.default.createElement(_Popover2.default.Title, {
    className: "popover-title ".concat(titleClassName)
  }, title), children && /*#__PURE__*/_react.default.createElement(_Popover2.default.Content, {
    className: "popover-content ".concat(contentClassName)
  }, children));
});

Popover.AUTO = _Tooltip.default.AUTO;
Popover.TOP = _Tooltip.default.TOP;
Popover.BOTTOM = _Tooltip.default.BOTTOM;
Popover.RIGHT = _Tooltip.default.RIGHT;
Popover.LEFT = _Tooltip.default.LEFT;
Popover.propTypes = {
  id: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]).isRequired,
  title: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),
  children: _propTypes.default.node.isRequired,
  titleClassName: _propTypes.default.string,
  contentClassName: _propTypes.default.string
};
var _default = Popover;
exports.default = _default;